"use client";

import { useEffect } from "react";
import { ensureStylesInjected } from "../styles";

/**
 * 在元件掛載時注入共用樣式（冪等，重複呼叫安全）。
 * 供所有 packages/ui 對外元件使用，取代依賴消費端 Tailwind 掃到本套件原始碼。
 */
export function useInjectStyles(): void {
  useEffect(() => {
    ensureStylesInjected();
  }, []);
}
